"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDom_1 = __importDefault(require("../util/getDom"));
const Collection_1 = __importDefault(require("./Collection"));
class Worlds extends Collection_1.default {
    fetch(number) {
        return __awaiter(this, void 0, void 0, function* () {
            const dom = yield getDom_1.default('http://oldschool.runescape.com/slu?order=WMLPA');
            const CollectionOfElements = Array.from(dom.window.document.getElementsByClassName('server-list__row'));
            for (const WorldRow of CollectionOfElements) {
                const columns = Array.from(WorldRow.children);
                if (!columns[0].textContent ||
                    !columns[1].textContent ||
                    !columns[2].textContent ||
                    !columns[3].textContent ||
                    !columns[4].textContent) {
                    continue;
                    //throw new Error('World element is missing text content.');
                }
                const worldNumber = parseInt(columns[0].textContent.replace(/\D/g, '')) + 300;
                const world = {
                    number: worldNumber,
                    players: parseInt(columns[1].textContent.replace(/\D/g, '')),
                    location: columns[2].textContent,
                    members: columns[3].textContent === 'Members',
                    activity: columns[4].textContent
                };
                this.set(worldNumber, world);
            }
            if (number)
                return this.get(number);
        });
    }
    get(number) {
        if (number < 300) {
            number += 300;
        }
        return super.get(number);
    }
}
exports.default = new Worlds();
//# sourceMappingURL=Worlds.js.map